import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-map-dialog',
    imports: [
    MatDialogModule
],
    templateUrl: './map-dialog.component.html',
    styleUrls: ['./map-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapDialogComponent {
  readonly #dialogRef = inject(MatDialogRef<MapDialogComponent>);
}
